import axiosInstance from "./AxiosInstance";

const AnalyticsService = {
  getAdminAnalytics: async (filters = {}) => {
    try {
      const {
        categoryIds = [],
        customerIds = [],
        userIds = [],
        taskIds = [],
        startDate,
        endDate,
      } = filters;

      const params = new URLSearchParams();
      
      categoryIds.forEach(id => params.append('categoryIds[]', id));
      customerIds.forEach(id => params.append('customerIds[]', id));
      userIds.forEach(id => params.append('userIds[]', id));
      taskIds.forEach(id => params.append('taskIds[]', id));
      
      if (startDate) params.append('startDate', startDate);
      if (endDate) params.append('endDate', endDate);

      const response = await axiosInstance.get(`/v1/analytics/admin/job?${params.toString()}`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error("Error in getAdminAnalytics:", error);
      return { success: false, error };
    }
  },

  getAdminCharts: async (filters = {}) => {
    try {
      const {
        categoryIds = [],
        customerIds = [],
        userIds = [],
        taskIds = [],
        startDate,
        endDate,
      } = filters;

      const params = new URLSearchParams();
      
      categoryIds.forEach(id => params.append('categoryIds[]', id));
      customerIds.forEach(id => params.append('customerIds[]', id));
      userIds.forEach(id => params.append('userIds[]', id));
      taskIds.forEach(id => params.append('taskIds[]', id));
      
      if (startDate) params.append('startDate', startDate);
      if (endDate) params.append('endDate', endDate);

      const response = await axiosInstance.get(`/v1/analytics/admin/job/charts?${params.toString()}`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error("Error in getAdminCharts:", error);
      return { success: false, error };
    }
  },

  getAdminOrganizationAnalytics: async () => {
    try {
      const response = await axiosInstance.get('/v1/analytics/admin/organization');
      return { success: true, data: response.data };
    } catch (error) {
      console.error("Error in getAdminOrganizationAnalytics:", error);
      return { success: false, error };
    }
  },

  getAdminComparisonAnalytics: async (filters1 = {}, filters2 = {}) => {
    try {
      const {
        categoryIds: categoryIds1 = [],
        customerIds: customerIds1 = [],
        userIds: userIds1 = [],
        taskIds: taskIds1 = [],
        startDate: startDate1,
        endDate: endDate1,
      } = filters1;

      const {
        categoryIds: categoryIds2 = [],
        customerIds: customerIds2 = [],
        userIds: userIds2 = [],
        taskIds: taskIds2 = [],
        startDate: startDate2,
        endDate: endDate2,
      } = filters2;

      let filtersSet1 = {};
      let filtersSet2 = {};

      if (categoryIds1.length > 0) {
        filtersSet1.categoryIds = categoryIds1;
      }

      if (customerIds1.length > 0) {
        filtersSet1.customerIds = customerIds1;
      }

      if (userIds1.length > 0) {
        filtersSet1.userIds = userIds1;
      }

      if (taskIds1.length > 0) {
        filtersSet1.taskIds = taskIds1;
      }

      if (startDate1) {
        filtersSet1.startDate = startDate1;
      }

      if (endDate1) {
        filtersSet1.endDate = endDate1;
      }

      if (categoryIds2.length > 0) {
        filtersSet2.categoryIds = categoryIds2;
      }

      if (customerIds2.length > 0) {
        filtersSet2.customerIds = customerIds2;
      }

      if (userIds2.length > 0) {
        filtersSet2.userIds = userIds2;
      }

      if (taskIds2.length > 0) {
        filtersSet2.taskIds = taskIds2;
      }

      if (startDate2) {
        filtersSet2.startDate = startDate2;
      }

      if (endDate2) {
        filtersSet2.endDate = endDate2;
      }

      const body = {
        filter1: filtersSet1,
        filter2: filtersSet2,
      };

      const response = await axiosInstance.post('/v1/analytics/admin/job/comparison', body);
      return { success: true, data: response.data };
    } catch (error) {
      console.error("Error in getAdminComparisonAnalytics:", error);
      return { success: false, error };
    }
  },

  getAdminComparisonCharts: async (filters1 = {}, filters2 = {}) => {
    try {
      const {
        categoryIds: categoryIds1 = [],
        customerIds: customerIds1 = [],
        userIds: userIds1 = [],
        taskIds: taskIds1 = [],
        startDate: startDate1,
        endDate: endDate1,
      } = filters1;

      const {
        categoryIds: categoryIds2 = [],
        customerIds: customerIds2 = [],
        userIds: userIds2 = [],
        taskIds: taskIds2 = [],
        startDate: startDate2,
        endDate: endDate2,
      } = filters2;

      let filtersSet1 = {};
      let filtersSet2 = {};

      if (categoryIds1.length > 0) {
        filtersSet1.categoryIds = categoryIds1;
      }

      if (customerIds1.length > 0) {
        filtersSet1.customerIds = customerIds1;
      }

      if (userIds1.length > 0) {
        filtersSet1.userIds = userIds1;
      }

      if (taskIds1.length > 0) {
        filtersSet1.taskIds = taskIds1;
      }

      if (startDate1) {
        filtersSet1.startDate = startDate1;
      }

      if (endDate1) {
        filtersSet1.endDate = endDate1;
      }

      if (categoryIds2.length > 0) {
        filtersSet2.categoryIds = categoryIds2;
      }

      if (customerIds2.length > 0) {
        filtersSet2.customerIds = customerIds2;
      }

      if (userIds2.length > 0) {
        filtersSet2.userIds = userIds2;
      }

      if (taskIds2.length > 0) {
        filtersSet2.taskIds = taskIds2;
      }

      if (startDate2) {
        filtersSet2.startDate = startDate2;
      }

      if (endDate2) {
        filtersSet2.endDate = endDate2;
      }

      const body = {
        filter1: filtersSet1,
        filter2: filtersSet2,
      };

      const response = await axiosInstance.post('/v1/analytics/admin/job/charts/comparison', body);
      return { success: true, data: response.data };
    } catch (error) {
      console.error("Error in getAdminComparisonAnalytics:", error);
      return { success: false, error };
    }
  },

  exportJobAnalytics: async (filters = {}) => {
    try {
      const {
        categoryIds = [],
        customerIds = [],
        userIds = [],
        taskIds = [],
        startDate,
        endDate,
      } = filters;

      const params = new URLSearchParams();
      
      categoryIds.forEach(id => params.append('categoryIds[]', id));
      customerIds.forEach(id => params.append('customerIds[]', id));
      userIds.forEach(id => params.append('userIds[]', id));
      taskIds.forEach(id => params.append('taskIds[]', id));
      
      if (startDate) params.append('startDate', startDate);
      if (endDate) params.append('endDate', endDate);
      params.append('format', 'csv');

      const response = await axiosInstance.get(`/v1/analytics/admin/job/export?${params.toString()}`, {
        responseType: 'blob',
        headers: {
          'Accept': 'text/csv'
        }
      });
      
      return { success: true, data: response.data };
    } catch (error) {
      console.error("Error in exportJobAnalytics:", error);
      return { success: false, error };
    }
  },

  exportComparisonAnalytics: async (filters1 = {}, filters2 = {}) => {
    try {
      const {
        categoryIds: categoryIds1 = [],
        customerIds: customerIds1 = [],
        userIds: userIds1 = [],
        taskIds: taskIds1 = [],
        startDate: startDate1,
        endDate: endDate1,
      } = filters1;

      const {
        categoryIds: categoryIds2 = [],
        customerIds: customerIds2 = [],
        userIds: userIds2 = [],
        taskIds: taskIds2 = [],
        startDate: startDate2,
        endDate: endDate2,
      } = filters2;

      let filtersSet1 = {};
      let filtersSet2 = {};

      if (categoryIds1.length > 0) {
        filtersSet1.categoryIds = categoryIds1;
      }

      if (customerIds1.length > 0) {
        filtersSet1.customerIds = customerIds1;
      }

      if (userIds1.length > 0) {
        filtersSet1.userIds = userIds1;
      }

      if (taskIds1.length > 0) {
        filtersSet1.taskIds = taskIds1;
      }

      if (startDate1) {
        filtersSet1.startDate = startDate1;
      }

      if (endDate1) {
        filtersSet1.endDate = endDate1;
      }

      if (categoryIds2.length > 0) {
        filtersSet2.categoryIds = categoryIds2;
      }

      if (customerIds2.length > 0) {
        filtersSet2.customerIds = customerIds2;
      }

      if (userIds2.length > 0) {
        filtersSet2.userIds = userIds2;
      }

      if (taskIds2.length > 0) {
        filtersSet2.taskIds = taskIds2;
      }

      if (startDate2) {
        filtersSet2.startDate = startDate2;
      }

      if (endDate2) {
        filtersSet2.endDate = endDate2;
      }

      const body = {
        filter1: filtersSet1,
        filter2: filtersSet2,
      };

      const response = await axiosInstance.post('/v1/analytics/admin/job/comparison/export?format=csv', body, {
        responseType: 'blob',
        headers: {
          'Accept': 'text/csv'
        }
      });
      
      return { success: true, data: response.data };
    } catch (error) {
      console.error("Error in exportComparisonAnalytics:", error);
      return { success: false, error };
    }
  },

  exportOrganizationAnalytics: async () => {
    try {
      const response = await axiosInstance.get('/v1/analytics/admin/organization/export?format=csv', {
        responseType: 'blob',
        headers: {
          'Accept': 'text/csv'
        }
      });
      
      return { success: true, data: response.data };
    } catch (error) {
      console.error("Error in exportOrganizationAnalytics:", error);
      return { success: false, error };
    }
  },
};

export default AnalyticsService; 